<script>
export default {
  name: 'Download',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    error: {
      type: Boolean,
      required: true,
    },
    errorMessage: {
      type: String,
      required: true,
    },
    info: {
      type: Array,
      default: undefined,
    },
  },
  computed: {
    computedDisabled() {
      return this.disabled || this.downloadLoading;
    },
  },
  methods: {
    downloadList() {
      this.$emit('download');
    },
  },
};
</script>

<template>
  <v-flex xs12 class="supplier-payments__download align-center">
    <span v-if="error" class="red--text mr-4">
      {{ errorMessage }}
    </span>
    <v-flex>
      <v-btn
        @click="downloadList"
        :disabled="computedDisabled"
        :loading="loading"
        color="primary darken-1"
        small
        block
      >
        <v-flex class="d-flex align-center">
          <v-icon class="pr-2">cloud_download</v-icon>
          <span>{{ $t('inputs.download') }}</span>
        </v-flex>
      </v-btn>
    </v-flex>

    <v-flex v-if="info" ml-2 supplier-payments__download-info>
      <v-tooltip :disabled="computedDisabled" left>
        <template slot="activator" slot-scope="{ on }">
          <span v-on="on">
            <v-icon :disabled="computedDisabled" size="28" color="primary">info</v-icon>
          </span>
        </template>
        <span class="supplier-payments__download-filter">
          <span>
            {{ $t('payments.filters.chosen') }}:
          </span>
          <br>
          <span v-for="(filter, index) in info" :key="'filter_' + index">
            {{ filter.label }}: {{ filter.value }}
          </span>
        </span>
      </v-tooltip>
    </v-flex>
  </v-flex>
</template>

<style lang="scss">
  .supplier-payments {
    &__download {
      position: absolute;
      top: 0;
      right: 0;
      display: inline-flex;

      &-info {
        margin-top: 2px !important;
      }

      &-filter span {
        display: block;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/payments/PaymentsDownload.vue